/**
 * Enumerations shared by the API, the web app, the CLI and the database.
 *
 * Every value here has a matching Postgres enum in packages/db/migrations.
 * Changing one means changing the other in the same commit (CLAUDE.md section 12).
 */
export const BOARD_CODES = ['AP_SSC', 'TS_SSC', 'CBSE'];
export const USER_ROLES = ['student', 'teacher', 'admin'];
/** Training level, set per student per topic by the teacher. */
export const LEVELS = ['beginner', 'intermediate', 'advanced'];
export const QUESTION_TYPES = ['mcq', 'short', 'long', 'word_problem'];
export const DIFFICULTIES = ['easy', 'medium', 'hard'];
export const SUGGESTION_STATUSES = ['open', 'approved', 'dismissed'];
export const TUTOR_ROLES = ['system', 'user', 'assistant'];
/** Practice items are multiple choice or a short numeric/text answer. */
export const PRACTICE_ITEM_TYPES = ['mcq', 'numeric', 'short_text'];
/**
 * Instruction language for the tutor. English only, by product decision.
 *
 * Section 3.1 asks for a Telugu-and-English option and a switch in the UI from
 * the first day. That is deliberately not built: Padhai is English only. The
 * enum stays as an enum with one member so the plumbing that carries a language
 * — the tutor session row, the prompt, the request schema — does not have to be
 * unpicked and re-added if that ever changes.
 *
 * `instruction_language` in Postgres still has the `te_en` value from migration
 * 0001. Removing a value from an enum type in use needs its own migration, and
 * nothing can write it now, so it is left alone rather than churned.
 */
export const LANGUAGES = ['en'];
export const LEVEL_ORDER = {
    beginner: 0,
    intermediate: 1,
    advanced: 2,
};
/** The level a newly released topic starts at for every student. */
export const DEFAULT_LEVEL = 'beginner';
export function nextLevelUp(level) {
    if (level === 'beginner')
        return 'intermediate';
    if (level === 'intermediate')
        return 'advanced';
    return null;
}
export function nextLevelDown(level) {
    if (level === 'advanced')
        return 'intermediate';
    if (level === 'intermediate')
        return 'beginner';
    return null;
}
//# sourceMappingURL=enums.js.map